// ==============================|| OVERRIDES - TABLE BODY ||============================== //

export default function TableBody(theme) {
  const hoverStyle = {
    "&:hover": {
      backgroundColor: theme.vars.palette.action.hover,
    },
  };

  return {
    MuiTableBody: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          "& .MuiTableRow-root": {
            ...hoverStyle,
          },
        },
      },
    },
  };
}
